module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/5e880b538887c26097290f3f96bad018.svg";